import { ErrorHandler } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "./logger.service";
export class GlobalErrorHandlerService {
    constructor(loggerService) {
        this.loggerService = loggerService;
    }
    handleError(error, message) {
        this.loggerService.error('GlobalErrorHandlerService catch error', error);
    }
}
GlobalErrorHandlerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GlobalErrorHandlerService_Factory() { return new GlobalErrorHandlerService(i0.ɵɵinject(i1.LoggerService)); }, token: GlobalErrorHandlerService, providedIn: "root" });
